import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { immigrationCleanByRules } from '@/store/party/partials/party-edit/helpers/pe-immigration-status-card'

export const PEImmigrationStatusCardActions = {
  initPeImmigrationStatusCard: ({ commit }, index) => {
    commit('setPeImmigrationStatusCardLock', { index, lock: true })
  },
  peImmigrationStatusCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    const cleanSection = immigrationCleanByRules(section)

    return axiosRequest.
      post('/party_characteristics', {
        immigration_statuses: {
          party_id: party.id,
          immigration_status: cleanSection.immigration_status,
          admission_category: cleanSection.admission_category,
          niv_type: cleanSection.niv_type,
          certificate_number: cleanSection.certificate_number,
          naturalization_certificate_number: cleanSection.naturalization_certificate_number,
          immigration_status_other: cleanSection.immigration_status_other,
          date_expires: cleanSection.date_expires,
          date_expires_format: cleanSection.date_expires_format,
          date_expires_uncertain: cleanSection.date_expires_uncertain,
          date_obtained: cleanSection.date_obtained,
          date_obtained_format: cleanSection.date_obtained_format,
          date_obtained_uncertain: cleanSection.date_obtained_uncertain,
          place_obtained: cleanSection.place_obtained,
          notes: cleanSection.notes,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeImmigrationStatusCardLock', { index, lock: true })
        commit('pePatchParty', {
          immigration_statuses: updatedParty.immigration_statuses || [],
        })
      }).
      catch(handleError)
  },
  peImmigrationStatusCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/immigration_statuses/${section.id}`).
      then(({ data }) => {
        commit('setPeImmigrationStatusCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'immigration_statuses',
          value: data,
        })
      }).
      catch(handleError)
  },
  peImmigrationStatusCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    const cleanSection = immigrationCleanByRules(section)

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        immigration_statuses: {
          party_id: party.id,
          immigration_status: cleanSection.immigration_status,
          admission_category: cleanSection.admission_category,
          niv_type: cleanSection.niv_type,
          certificate_number: cleanSection.certificate_number,
          naturalization_certificate_number: cleanSection.naturalization_certificate_number,
          immigration_status_other: cleanSection.immigration_status_other,
          date_expires: cleanSection.date_expires,
          date_expires_format: cleanSection.date_expires_format,
          date_expires_uncertain: cleanSection.date_expires_uncertain,
          date_obtained: cleanSection.date_obtained,
          date_obtained_format: cleanSection.date_obtained_format,
          date_obtained_uncertain: cleanSection.date_obtained_uncertain,
          place_obtained: cleanSection.place_obtained,
          notes: cleanSection.notes,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeImmigrationStatusCardLock', { index, lock: true })
        commit('pePatchParty', {
          immigration_statuses: updatedParty.immigration_statuses || [],
        })
      }).
      catch(handleError)
  },
  peImmigrationStatusCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          immigration_statuses: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeImmigrationStatusCardLock', { index, lock: true })
        commit('pePatchParty', {
          immigration_statuses: updatedParty.immigration_statuses || [],
        })
      }).
      catch(handleError)
  },
  peImmigrationStatusCardAddSection: ({ commit }) => {
    commit('setPeImmigrationStatusCardLock', { index: 'new', lock: false })
    commit('addPeImmigrationStatusCardSection', {
      id: null,
      immigration_status: null,
      admission_category: null,
      niv_type: null,
      certificate_number: null,
      naturalization_certificate_number: null,
      immigration_status_other: null,
      date_expires: null,
      date_expires_format: null,
      date_expires_uncertain: null,
      date_obtained: null,
      date_obtained_format: null,
      date_obtained_uncertain: null,
      place_obtained: null,
      notes: null,
    })
  },
}

export const PEImmigrationStatusCardMutations = {
  setPeImmigrationStatusCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.ImmigrationStatusCard) {
      Vue.set(state.partyEdit.partySections, 'ImmigrationStatusCard', {})
    }
    Vue.set(state.partyEdit.partySections.ImmigrationStatusCard, index, lock)
  },
  addPeImmigrationStatusCardSection: (state, section) => {
    state.partyEdit.party.immigration_statuses.push(section)
  },
  peImmigrationStatusCardCreateUndo: state => state.partyEdit.party.immigration_statuses.pop(),
}

export const PEImmigrationStatusCardGetters = {
  peImmigrationStatusCardLock: state => index => state.partyEdit.partySections.ImmigrationStatusCard[index],
  peImmigrationStatusCardHasNewSection: (_, getters) => !!getters.
    peParty.
    immigration_statuses?.
    find(aka => aka.id === null),
}
